import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Field } from 'redux-form';
import ToggleField from '../app-main/components/reduxForms/fields/ToggleField/ToggleField';

const OvernightStaysField = ({ intl }) => {
  const translationMessages = defineMessages({
    yes: {
      id: 'hosting.overnight_stays.yes_label',
      defaultMessage: 'Yes'
    },
    no: {
      id: 'hosting.overnight_stays.no_label',
      defaultMessage: 'No'
    }
  });
  return (
    <div>
      <div className='flex column relative'>
        <h2 className=''>
          <FormattedMessage
            id='hosting.overnight_stays_field.title'
            defaultMessage='Do you offer overnight stays at this space?'
          />
        </h2>
        <div className='flex flex-start column-sm space-between text-large'>
          <span className='margin-md-right'>
            <FormattedMessage
              id='hosting.overnight_stays_field.overnight_stay_description'
              defaultMessage="Select 'Yes' if your space is listed on sites like Airbnb or VRBO, or if it's a hotel or similar establishment that's subject to lodging taxes."
            />
          </span>
          <div className='toggle-field'>
            <Field
              name='overnight_stays'
              className='flex'
              component={ToggleField}
              attributes={{
                'data-testing-id': 'overnight-stays-toggle',
                name: 'overnight_stays'
              }}
              firstOption={{
                id: 'overnight-stays-true',
                value: 'true',
                label: intl.formatMessage(translationMessages.yes)
              }}
              secondOption={{
                id: 'overnight-stays-false',
                value: 'false',
                label: intl.formatMessage(translationMessages.no)
              }}
              errorPositionedClassName='error-positioned no-bottom-margin'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(OvernightStaysField);
